import { FramerNextPages } from '@graphcommerce/framer-next-pages'
import { GoogleTagManagerScript } from '@graphcommerce/googletagmanager'
import { GraphQLProvider } from '@graphcommerce/graphql'
import { GlobalHead } from '@graphcommerce/magento-store'
import {
  CssAndFramerMotionProvider,
  DarkLightModeThemeProvider,
  PageLoadIndicator,
} from '@graphcommerce/next-ui'
import { CssBaseline } from '@mui/material'
import { AppProps } from 'next/app'
import { lightTheme, darkTheme } from '../components/theme'
import { I18nProvider } from '../lib/i18n/I18nProvider'
import './style.css'
import { useEffect } from 'react'

export default function ThemedApp(props: AppProps) {
  const { router } = props
  const { locale = 'it' } = router

  useEffect(() => {
    router.prefetch = async () => {}
  }, [router])

  return (
    <CssAndFramerMotionProvider>
      <I18nProvider key={locale} locale={locale}>
        <GraphQLProvider {...props}>
          <DarkLightModeThemeProvider light={lightTheme} dark={darkTheme}>
            <GlobalHead />
            <CssBaseline />
            <PageLoadIndicator />
            <FramerNextPages {...props} />
          </DarkLightModeThemeProvider>
        </GraphQLProvider>
      </I18nProvider>
      <GoogleTagManagerScript />
    </CssAndFramerMotionProvider>
  )
}
